import React from "react";
import PropTypes from "prop-types";
import "./InputField.scss";

const InputField = ({
  label,
  required = false,
  as: Component = "input",
  id,
  name,
  ...props
}) => {
  const fieldId = id || name;

  return (
    <div className="input-field">
      {label && (
        <label htmlFor={fieldId}>
          {label}
          {required && <span className="required-asterisk"> *</span>}
        </label>
      )}
      <Component id={fieldId} name={name} {...props} />
    </div>
  );
};

InputField.propTypes = {
  label: PropTypes.string,
  required: PropTypes.bool,
  id: PropTypes.string,
  name: PropTypes.string,
  as: PropTypes.elementType,
};

export default InputField;
